export const userActionsTypes = {
	ACCESS_LIST: 'ACCESS_LIST',
	TIME_INTERVALS: 'TIME_INTERVALS',
	ALERTS_COUNT: 'ALERTS_COUNT',
};
